import { type RefObject, useEffect, useState } from 'react';

const findScrollParent = (element: HTMLElement): HTMLElement | null => {
  let node = element.parentElement;
  while (node) {
    const { overflowY } = getComputedStyle(node);
    if (overflowY === 'auto' || overflowY === 'scroll') return node;
    node = node.parentElement;
  }
  return null;
};

export const useLazyInView = (elementRef: RefObject<HTMLElement | null>) => {
  const [shouldLoad, setShouldLoad] = useState(typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    if (shouldLoad) return;
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoad(true);
      observer.disconnect();
    }, {
      root: findScrollParent(element),
      rootMargin: '1000px',
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [elementRef, shouldLoad]);

  return shouldLoad;
};
